import {
  Container,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableFooter
} from "@mui/material";
import React from "react";

const Comp9PDF = ({
    formData,
    rentalItems,
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5, borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">SDGs 子ども・ユースフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">装飾備品レンタル申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_9_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_9_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_9_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_9_tel}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求先メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>
        </Box>   
        <Box sx={{mt: 2}}>
            <Table size="small">
            <TableHead>
                <TableRow>
                <TableCell sx={{width: '65px'}}>品番</TableCell>
                <TableCell>品名</TableCell>
                <TableCell sx={{width: '100px'}}>単価(税込)</TableCell>
                <TableCell>数量</TableCell>
                <TableCell>合計</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {rentalItems.map((item) => {
                const detail = formData?.details.find(d => d.item_id === item.item_id);
                const number = detail?.number || 0;

                if (number <= 0) return null;

                const unitTotal = item.unit_price * number;
                const colorValue =
                item.item_id === "38"
                    ? formData?.carpet_color
                    : item.item_id === "39"
                    ? formData?.sheet_color
                    : "";

                return (
                <React.Fragment key={item.item_id}>
                    <TableRow>
                    <TableCell>{item.item_id}</TableCell>
                    <TableCell>{item.item_name}</TableCell>
                    <TableCell>¥{item.unit_price.toLocaleString()}</TableCell>
                    <TableCell>{number}</TableCell>
                    <TableCell>¥{unitTotal.toLocaleString()}</TableCell>
                    </TableRow>

                    {(item.item_id === "38" || item.item_id === "39") && (
                    <TableRow>
                        <TableCell colSpan={5}>
                        {colorValue || "未選択"}
                        </TableCell>
                    </TableRow>
                    )}
                </React.Fragment>
                );
            })}
            </TableBody>
            <TableFooter>
            <TableRow>
                <TableCell colSpan={4} align="right">
                <Typography variant="subtitle1">総合計金額:</Typography>
                </TableCell>
                <TableCell>
                <Typography variant="subtitle1">
                    ¥{(formData?.total_price ?? 0).toLocaleString()}
                </Typography>
                </TableCell>
            </TableRow>
            </TableFooter>
            </Table>
            <Typography variant="h6">備考欄</Typography>
            <Typography color="error">※装飾備品レンタル申込について補足事項等がある場合はコチラにご入力ください。</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {formData?.alfa_text}
            </Typography>
        </Box>
        </>
        )}
    </Box>
    </Container>
  );
};

export default Comp9PDF;
